import angular from 'angular';

import '../../../main/factory/order_transaction';
import '../../../main/factory/authentication';
import '../../../core/main/factory/analytics';
import '../../../core/main/directive/decimal/directive'
import '../../../core/main/directive/greater_than/directive'
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.module.order.refund", [
    "merchant.application.module.order.summary"
]).controller("merchant.application.module.order.refund.controller", [
    "$rootScope", "$scope", "$controller", "$location",
    "merchant.application.main.factory.orderTransaction",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.analytics",
    function($rootScope, $scope, $controller, $location, OrderTransaction, Authentication, Analytics) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.orderRefund) {
            $scope.model.orderRefund = {};
        }
        $scope.model.orderRefund.refundAmount = null;
        $scope.model.orderRefund.password = null;
        $scope.model.orderRefund.isRefundApproved = false;
        $scope.model.orderRefund.currentError = null;
        $scope.model.orderRefund.showPassword = !Authentication.ssoUser();

        $scope.submitRefund = function() {
            $scope.model.orderRefund.currentError = null;
            if ($scope.form.$valid) {
                $scope.model.orderRefund.refundedAmount = parseFloat($scope.model.orderRefund.refundAmount).toFixed(2);

                const password = Authentication.ssoUser() ? "" : $scope.model.orderRefund.password;
                const parameters = {
                    password,
                    amount: {
                        amount: $scope.model.orderRefund.refundedAmount,
                        currency: $scope.model.orderRefund.merchantAmount.currency
                    },
                };
                const merchantId = Authentication.merchantId()
                const transactionId = $scope.model.orderRefund.id
 
                Analytics.sendAmplitudeEvent("Clicked the Issue Refund button", { merchantId, transactionId });

                OrderTransaction.refund(
                    { merchantId, transactionId },
                    parameters,
                    function (response) {
                        response.amount.amount = Math.abs(response.amount.amount);
                        $scope.model.orderRefund.isRefundApproved = true;
                        $rootScope.$broadcast("refundedOrder", response.orderTransaction);
                    },
                    function (error) {
                        $scope.model.orderRefund.isRefundApproved = false;
                        $scope.model.orderRefund.currentError = error.data && error.data.errorCode;
                        if ($scope.model.orderRefund.currentError === "authentication_failure") {
                            // PAYL-5413 The 401 status code triggers the display of the global error handling in the header.
                            // In this case we don't want to display the error in the header, so we manually hide it.
                            $rootScope.unauthorisedError = false;
                        } else if ($scope.model.orderRefund.currentError === "forbidden") {
                            $location.path("logout");
                        }
                    }
                );
            }
        };

    }
]);
